import '../ContentPageModals.scss';
import './ChecklistEditModal.scss';

import React from 'react';
import update from 'immutability-helper';
import clone from 'clone';

import ChecklistEditForm from './ChecklistEditForm';
import Modal from 'components/Modal';
import Thumbnail from 'components/Thumbnail';

export default class ChecklistEditModal extends React.Component {
    static propTypes = {
        closeModal: React.PropTypes.func.isRequired,
        contentPiece: React.PropTypes.object.isRequired,
        isSaving: React.PropTypes.bool.isRequired,
        openAddChecklistItemModal: React.PropTypes.func.isRequired,
        saveContentSingle: React.PropTypes.func.isRequired,
        setContentSingle: React.PropTypes.func.isRequired,
        show: React.PropTypes.bool.isRequired
    };

    handleChange(event) {
        let name = event.target.getAttribute('name');
        let value = event.target.value;
        if(event.target.type === 'checkbox') {
            value = event.target.checked;
        }
        let newContentObj = update(this.props.contentPiece, {});
        newContentObj[name] = value;

        this.props.setContentSingle(newContentObj);
    }

    handleSubmit(isValid) {
        if(isValid === true) {
            this.props.saveContentSingle();
        }
    }

    handleThumbnailChange(file) {
        console.log(file);
        let newContentObj = update(this.props.contentPiece, {
            thumbnail: { $set: file}
        });

        this.props.setContentSingle(newContentObj);
    }

    removeChecklistItem(index) {
        let items = clone(this.props.contentPiece.items);
        /*for(var i = 0, l = items.length; i < l; i++) {

        }*/
        items.splice(index, 1);
        let newContentObj = update(this.props.contentPiece, {
            items: { $set: items}
        });

        this.props.setContentSingle(newContentObj);
    }

    render() {
        let { closeModal, contentPiece, show } = this.props;

        return (
            <Modal show={show}
                   className="content-edit checklist-edit edit-modal"
                   handleClose={closeModal.bind(this)}
                   width="wide">
                <header className="checklist-edit__header edit-modal__header">
                    <div className="edit-modal__thumbnail checklist-edit__thumbnail upload-thumbnail">
                        <Thumbnail
                            defaultAvatar="checklist"
                            dropzone={true}
                            handleDrop={this.handleThumbnailChange.bind(this)}
                            imgTag
                            thumbnailID={contentPiece.thumbnail && contentPiece.thumbnail.id ? contentPiece.thumbnail.id : null}
                            thumbnailToUpload={contentPiece.thumbnail && contentPiece.thumbnail.constructor === File ? contentPiece.thumbnail : null}
                        />
                    </div>
                </header>
                <div className="content-edit__form-wrapper">
                    <ChecklistEditForm
                        closeModal={closeModal.bind(this)}
                        contentPiece={contentPiece}
                        handleChange={this.handleChange.bind(this)}
                        isSaving={this.props.isSaving}
                        openAddChecklistItemModal={this.props.openAddChecklistItemModal.bind(this)}
                        removeChecklistItem={this.removeChecklistItem.bind(this)}
                        onInvalid={this.handleSubmit.bind(this, false)}
                        onValid={this.handleSubmit.bind(this, true)}
                        setContentSingle={this.props.setContentSingle.bind(this)}
                    />
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/ContentPage/modals/ChecklistEditModal/index.js